<template>
  <CCard>
    <CCardBody class="ccard-body">
      <div class="mr-3">
        <h1 v-if="isUnsubscribed" class="text-center mb-0">
          {{$t('unsubscribe_confirmation')}}
        </h1>
        <CButton color="primary" @click="unsubscribe" v-else size="lg">
          {{$t('unsubscribe_text')}}
        </CButton>
      </div>
      <img
        src="/img/unsubscribe.svg"
        alt=""
        class="img-fluid"
        style="min-height: 200px"
      />
    </CCardBody>
  </CCard>
</template>

<script>
import { FormService } from "@/services/form";

export default {
  name: "Unsubscribe",
  data() {
    return {
      isUnsubscribed: false,
    };
  },
  methods: {
    unsubscribe() {
      FormService.unsubscribe(this.$route.params.formId);
      this.isUnsubscribed = true;
    },
  },
};
</script>
<style lang="scss">
  .ccard-body{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  @media (max-width: map-get($container-max-widths, "sm")) {
  .ccard-body{
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    .btn{
      margin-top: 1em;
    }
    h1 {
      margin-top: 0.5em;
    }
  }
}
</style>
